<div class="alert-container" [ngClass]="type" [class.dense]="dense">
  <div class="title-container">
    <mat-icon *ngIf="!hideIcon" class="material-symbols-outlined" [ngClass]="{ flat: isIconFlat }">{{icon}}</mat-icon>
    <h3 *ngIf="title">{{title}}</h3>
  </div>

  <p class="complement">
    <ng-content></ng-content>
  </p>
</div>